// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"39a2785f","144":"7676a857","244":"f154b1fa","378":"cd8fac74","572":"4ccc48e3","997":"f7086edd"}[chunkId] + ".chunk.css";
};